import { haptic } from '../utils/haptic';
import './PillSelector.css';

interface PillSelectorProps {
  options: string[];
  value: string;
  onChange: (val: string) => void;
}

export function PillSelector({ options, value, onChange }: PillSelectorProps) {
  return (
    <div className="pill-selector">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={`pill-option ${opt === value ? 'active' : ''}`}
          onClick={() => {
            haptic.select();
            onChange(opt);
          }}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
